



























import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Card, Icon } from '@alpha/ink'
import store from '@/store'
import { DEFAULT_TEST_TITLE } from '@/store/modules/test-creation-store-module'
import { TestStatus } from '@shared/types/database'

@Component({
  components: {
    Card,
    Icon
  }
})
export default class TestTitleInput extends Vue {
  @Prop({ required: true }) title!: string
  @Prop({ required: true }) testId!: string
  @Prop({ required: true }) workspaceId!: string
  @Prop({ required: true }) status!: TestStatus

  newTitle = this.title
  maxTitleLength = 60
  editing = false
  saving = false

  @Watch('title')
  titlePropChanged () {
    this.newTitle = this.title
  }

  get titleChanged () {
    return this.newTitle !== this.title
  }

  get isDraft () {
    return this.status === TestStatus.Draft
  }

  get editMessage () {
    if (this.staticHeaderStyle) {
      return 'Click to edit test title'
    } else {
      return ''
    }
  }

  get staticHeaderStyle () {
    return !this.isDraft && !this.editing
  }

  get titleCharLimit () {
    return `${this.newTitle.length}/${this.maxTitleLength}`
  }

  get defaultTestTitle () {
    return DEFAULT_TEST_TITLE
  }

  async saveTestTitle () {
    this.editing = false
    if (this.newTitle === '') {
      this.newTitle = DEFAULT_TEST_TITLE
    }
    if (this.newTitle === this.title) return
    this.saving = true
    await store.dispatch.workspace.updateTest({
      testId: this.testId,
      workspaceId: this.workspaceId,
      test: { title: this.newTitle }
    })
    this.saving = false
  }
}
